class KapinuaColorsActionTypes {
    static loadColors = {
        start: 'LOAD_KAPINUA_COLORS_START',
        success: 'LOAD_KAPINUA_COLORS_SUCCESS',
        fail: 'LOAD_KAPINUA_COLORS_FAIL',
    };
}

export default KapinuaColorsActionTypes;
